import React from "react";
import { adminRequest } from "../../../utils/requestMethods";
import Loader from "../../../components/Loader/Loader";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import CustomForm from "../../../components/CustomForm/CustomForm";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../../../utils/config";

const EditRoutinePeriod = () => {
  const location = useLocation();
  const activeURL = location.pathname.split("/")[5];
  const initialFormData = {
    effectiveFrom: "",
    effectiveTo: "",
    enrollmentSetupId: "",
  };
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormData);
  const [data, setData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [enrollment, setEnrollments] = useState([]);

  useEffect(() => {
    const fetchEnrollment = async () => {
      try {
        const response = await adminRequest.get(
          `${BASE_URL}/enrollmentSetup/list`,
        );
        setEnrollments(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchEnrollment();
  }, []);

  useEffect(() => {
    const fetchRoutinePeriod = async () => {
      try {
        const response = await adminRequest.post(
          `${BASE_URL}/routinePeriod/view`,
          {
            uuid: `${activeURL}`,
          },
        );
        setData(response.data);
        setFormData({
          effectiveFrom: response.data.data.effectiveFrom,
          effectiveTo: response.data.data.effectiveTo,
          enrollmentSetupId: response.data.data.enrollmentSetupId,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchRoutinePeriod();
  }, [activeURL]);

  if (!data) {
    return <Loader />;
  }
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/routinePeriod/edit`, {
          uuid: activeURL,
          effectiveFrom: formData.effectiveFrom,
          effectiveTo: formData.effectiveTo,
          enrollmentSetupId: formData.enrollmentSetupId,
        }),
        {
          pending: "Updating routine period",
        },
      );

      toast.success(response.data.message, {
        autoClose: 500,
        onClose: () => navigate(-1),
      });

      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fields = [
    {
      name: "enrollmentSetupId",
      label: "Enrollment",
      type: "select",
      value: formData.enrollmentSetupId,
      onChange: handleChange,
      options: [
        { label: "Select Enrollment", value: "" },
        ...enrollment.map((p) => ({
          label: p.enrollmentBatch,
          value: p.id,
        })),
      ],
    },
    {
      name: "effectiveFrom",
      label: "Effective From",
      type: "date",
      value: formData.effectiveFrom,
      onChange: handleChange,
    },
    {
      name: "effectiveTo",
      label: "Effective To",
      type: "date",
      value: formData.effectiveTo,
      onChange: handleChange,
    },
  ];
  return (
    <div className="editRoutinePeriodContainer">
      <CustomForm
        header="Edit Routine Period"
        fields={fields}
        flexDirection="row"
        createButtonLabel="Update"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <ToastContainer position="top-center" />
    </div>
  );
};

export default EditRoutinePeriod;
